module.exports = __webpack_public_path__ + "static/img/female-bg-es.52bea3ab.png";